import headerImgEn from "assets/images/v127/header-en.webp"
import infoImgEn from "assets/images/v127/info-en.webp"

export const v127ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
